import { graphql } from '@shared/api/gql';

export const sectionQueryDocument = graphql(`
	query GetSectionMorningstar($id: ID!) {
		section(id: $id) {
			id
			position
			name
			issues {
				id
				position
				name
				description
				cover
				externalUrl
				price
				features
				currency
				slug
				data
				releaseDate
				features
				updated
				isPaid
				created
				isPurchased
			}
		}
	}
`);
